(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9560],{

/***/ 79560:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Layout; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(10092);
// EXTERNAL MODULE: ./node_modules/@mui/material/Box/Box.js + 1 modules
var Box = __webpack_require__(87357);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
var router_default = /*#__PURE__*/__webpack_require__.n(next_router);
// EXTERNAL MODULE: ./components/common/Logo.module.css
var Logo_module = __webpack_require__(40107);
var Logo_module_default = /*#__PURE__*/__webpack_require__.n(Logo_module);
;// CONCATENATED MODULE: ./components/common/Logo.tsx





function Logo() {
    var router = (0,next_router.useRouter)();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
        className: (Logo_module_default()).logo,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
            onClick: function() {
                return router.push("/");
            },
            priority: true,
            src: "/images/logo.svg",
            alt: "logo",
            layout: "responsive",
            width: "300",
            height: "142"
        })
    });
}

// EXTERNAL MODULE: ./node_modules/@mui/material/IconButton/IconButton.js + 1 modules
var IconButton = __webpack_require__(93946);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/PersonOutlineOutlined.js
var PersonOutlineOutlined = __webpack_require__(73079);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/ShoppingCartOutlined.js
var ShoppingCartOutlined = __webpack_require__(46624);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/Search.js
var Search = __webpack_require__(42761);
// EXTERNAL MODULE: ./node_modules/@mui/material/useMediaQuery/useMediaQuery.js
var useMediaQuery = __webpack_require__(98396);
// EXTERNAL MODULE: ./node_modules/@mui/material/Typography/Typography.js + 1 modules
var Typography = __webpack_require__(15861);
// EXTERNAL MODULE: ./node_modules/@mui/material/Button/Button.js + 1 modules
var Button = __webpack_require__(11057);
// EXTERNAL MODULE: ./node_modules/@mui/material/Badge/Badge.js + 2 modules
var Badge = __webpack_require__(90263);
// EXTERNAL MODULE: ./node_modules/@mui/material/Menu/Menu.js + 3 modules
var Menu = __webpack_require__(44347);
// EXTERNAL MODULE: ./node_modules/@mui/material/MenuItem/MenuItem.js + 1 modules
var MenuItem = __webpack_require__(18972);
// EXTERNAL MODULE: ./node_modules/react-i18next/dist/es/useTranslation.js + 3 modules
var useTranslation = __webpack_require__(77058);
// EXTERNAL MODULE: ./components/layout/Navbar.module.css
var Navbar_module = __webpack_require__(6022);
var Navbar_module_default = /*#__PURE__*/__webpack_require__.n(Navbar_module);
// EXTERNAL MODULE: ./node_modules/@mui/material/Link/Link.js + 2 modules
var Link = __webpack_require__(23795);
// EXTERNAL MODULE: ./components/buttons/MarketplaceSearchButton.module.css
var MarketplaceSearchButton_module = __webpack_require__(99640);
var MarketplaceSearchButton_module_default = /*#__PURE__*/__webpack_require__.n(MarketplaceSearchButton_module);
// EXTERNAL MODULE: ./lib/constants.ts
var constants = __webpack_require__(59953);
;// CONCATENATED MODULE: ./components/buttons/MarketplaceSearchButton.tsx







function MarketplaceSearchButton() {
    var t = (0,useTranslation/* useTranslation */.$)().t;
    var router = (0,next_router.useRouter)();
    var isMobile = (0,useMediaQuery/* default */.Z)("(max-width:".concat(constants/* MOBILE_WIDTH_LIMIT */.x9, "px)"));
    var isTablet = (0,useMediaQuery/* default */.Z)("(max-width:".concat(constants/* TABLET_WIDTH_LIMIT */.OE, "px)"));
    var isSearchView = router.pathname === "/search";
    if (isSearchView || isMobile) return null;
    if (isTablet) return /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
        href: "/search",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton/* default */.Z, {
            "aria-label": "user",
            size: "large",
            color: "primary",
            className: (MarketplaceSearchButton_module_default()).nav__button,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Search/* default */.Z, {
                className: (MarketplaceSearchButton_module_default()).nav__button__icon
            })
        })
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
        variant: "outlined",
        className: (MarketplaceSearchButton_module_default()).button,
        startIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(Search/* default */.Z, {}),
        onClick: function() {
            router.push("/search");
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
            variant: "button",
            children: t("common.search_marketplaces")
        })
    });
}

// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/AccountCircle.js
var AccountCircle = __webpack_require__(28201);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/Logout.js
var Logout = __webpack_require__(13540);
// EXTERNAL MODULE: ./lib/supabaseClient.ts + 43 modules
var supabaseClient = __webpack_require__(66508);
// EXTERNAL MODULE: ./lib/supabaseApi.ts
var supabaseApi = __webpack_require__(19627);
// EXTERNAL MODULE: ./context/Auth.tsx
var Auth = __webpack_require__(34100);
// EXTERNAL MODULE: ./node_modules/@sentry/core/esm/exports.js
var esm_exports = __webpack_require__(64487);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/esm/Wallet.js
var Wallet = __webpack_require__(40042);
// EXTERNAL MODULE: ./components/businessLayout/InviteFriendInfoModal.tsx
var InviteFriendInfoModal = __webpack_require__(40918);
;// CONCATENATED MODULE: ./components/common/UserWalletLinkIcon.tsx












function UserWalletLinkIcon() {
    var t = (0,useTranslation/* useTranslation */.$)().t;
    var ref = (0,react.useState)(), userDB = ref[0], setUserDB = ref[1];
    var user = (0,Auth/* useAuth */.a)().user;
    var ref1 = (0,react.useState)(null), anchorElWallet = ref1[0], setAnchorElWallet = ref1[1];
    var ref2 = (0,react.useState)(false), infoModalOpen = ref2[0], setInfoModalOpen = ref2[1];
    var open = Boolean(anchorElWallet);
    var handleClickWallet = function(event) {
        setAnchorElWallet(event.currentTarget);
    };
    var handleCloseWallet = function() {
        setAnchorElWallet(null);
    };
    var interval = undefined;
    (0,react.useEffect)(function() {
        getUserInfo();
        if (!interval) timer();
    }, []);
    function getUserInfo() {
        return _getUserInfo.apply(this, arguments);
    }
    function _getUserInfo() {
        _getUserInfo = (0,_async_to_generator/* default */.Z)(function() {
            var data;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!user) return [
                            2,
                            null
                        ];
                        return [
                            4,
                            supabaseClient/* default.from */.Z.from("users").select("id, referral_code, wallet_balance").eq("supabase_user_id", user.id).single()
                        ];
                    case 1:
                        data = _state.sent().data;
                        if (data) setUserDB(data);
                        return [
                            2
                        ];
                }
            });
        });
        return _getUserInfo.apply(this, arguments);
    }
    var timer = function() {
        interval = setInterval(getUserInfo, 30000);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton/* default */.Z, {
                onClick: handleClickWallet,
                "aria-label": "invite_friend",
                size: "large",
                color: "primary",
                className: (Navbar_module_default()).nav__button,
                style: {
                    zIndex: 100
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Badge/* default */.Z, {
                    color: "primary",
                    badgeContent: "".concat((userDB === null || userDB === void 0 ? void 0 : userDB.wallet_balance) || 0, "€"),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Wallet/* default */.Z, {
                        className: (Navbar_module_default()).nav__button__icon__auth
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Menu/* default */.Z, {
                id: "basic-wallet-menu",
                anchorEl: anchorElWallet,
                open: open,
                onClose: handleCloseWallet,
                MenuListProps: {
                    "aria-labelledby": "basic-button"
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(MenuItem/* default */.Z, {
                        style: {
                            justifyContent: "center"
                        },
                        onClick: function(e) {
                            e.preventDefault();
                            router_default().push("/invite_friend");
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                            style: {
                                cursor: "pointer"
                            },
                            className: (Navbar_module_default()).nav__button__text,
                            children: t("common.invite_a_friend")
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(MenuItem/* default */.Z, {
                        style: {
                            justifyContent: "center"
                        },
                        onClick: function(e) {
                            e.preventDefault();
                            setInfoModalOpen(true);
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                            style: {
                                cursor: "pointer"
                            },
                            className: (Navbar_module_default()).nav__button__text,
                            children: t("pages.invite_friend.wallet_history")
                        })
                    })
                ]
            }),
            (userDB === null || userDB === void 0 ? void 0 : userDB.id) && /*#__PURE__*/ (0,jsx_runtime.jsx)(InviteFriendInfoModal/* default */.Z, {
                userId: userDB.id,
                open: infoModalOpen,
                setOpen: setInfoModalOpen
            })
        ]
    });
}

;// CONCATENATED MODULE: ./components/layout/Navbar.tsx













// import HomeOutlinedIcon from '@mui/icons-material/HomeOutlined'










function Navbar(param) {
    var menuIsExpanded = param.menuIsExpanded, setMenuIsExpanded = param.setMenuIsExpanded, user = param.user;
    var t = (0,useTranslation/* useTranslation */.$)().t;
    var router = (0,next_router.useRouter)();
    var isMobile = (0,useMediaQuery/* default */.Z)("(max-width:".concat(constants/* MOBILE_WIDTH_LIMIT */.x9, "px)"));
    var ref = (0,react.useState)(false), authenticated = ref[0], setAuthenticated = ref[1];
    var ref1 = (0,react.useState)(0), itemCount = ref1[0], setItemCount = ref1[1];
    var ref2 = (0,react.useState)([]), userNotifications = ref2[0], setUserNotifications = ref2[1];
    var ref3 = (0,react.useState)(), userDB = ref3[0], setUserDB = ref3[1];
    var signOut = (0,Auth/* useAuth */.a)().signOut;
    var ref4 = (0,react.useState)(null), anchorEl = ref4[0], setAnchorEl = ref4[1];
    var open = Boolean(anchorEl);
    var handleClickUser = function(event) {
        setAnchorEl(event.currentTarget);
    };
    var handleCloseUser = function() {
        setAnchorEl(null);
    };
    var getWalletAmount = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            var userDB;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            (0,supabaseApi/* getUserWalletInfo */.Yx)()
                        ];
                    case 1:
                        userDB = _state.sent();
                        setUserDB(userDB);
                        return [
                            2
                        ];
                }
            });
        });
        return function getWalletAmount() {
            return _ref.apply(this, arguments);
        };
    }();
    (0,react.useEffect)(function() {
        setTimeout(function() {
            setAuthenticated(!!supabaseClient/* default.auth.user */.Z.auth.user());
        }, 500) // This time is necessary to have the user properly loaded
        ;
        var getItemCount = function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function() {
                var itemCount;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            return [
                                4,
                                (0,supabaseApi/* getCartItemsNumber */.Dk)()
                            ];
                        case 1:
                            itemCount = _state.sent();
                            setItemCount(itemCount);
                            return [
                                2
                            ];
                    }
                });
            });
            return function getItemCount() {
                return _ref.apply(this, arguments);
            };
        }();
        var getNotificationUser = function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function() {
                var userNotifications;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            return [
                                4,
                                (0,supabaseApi/* getUserNotifications */.gG)()
                            ];
                        case 1:
                            userNotifications = _state.sent();
                            setUserNotifications(userNotifications);
                            return [
                                2
                            ];
                    }
                });
            });
            return function getNotificationUser() {
                return _ref.apply(this, arguments);
            };
        }();
        getItemCount();
        getNotificationUser();
        getWalletAmount();
    }, [
        router.asPath
    ]);
    var menuAction = function() {
        return setMenuIsExpanded(!menuIsExpanded);
    };
    var closeMenu = function() {
        return setMenuIsExpanded(false);
    };
    var logout = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            signOut()
                        ];
                    case 1:
                        _state.sent();
                        router.push("/login");
                        esm_exports/* setUser */.av(null);
                        return [
                            2
                        ];
                }
            });
        });
        return function logout() {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(MarketplaceSearchButton, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("nav", {
                className: (Navbar_module_default()).nav,
                children: [
                    isMobile && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                href: "#",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton/* default */.Z, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                        onClick: menuAction,
                                        className: (Navbar_module_default()).nav__button__text,
                                        children: t("common.menu")
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                href: "/search",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton/* default */.Z, {
                                    onClick: closeMenu,
                                    "aria-label": "user",
                                    size: "large",
                                    color: "primary",
                                    className: (Navbar_module_default()).nav__button,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Search/* default */.Z, {
                                        className: (Navbar_module_default()).nav__button__icon
                                    })
                                })
                            })
                        ]
                    }),
                    !isMobile && /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                        href: "/help",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                            variant: "text",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                style: {
                                    cursor: "pointer"
                                },
                                className: (Navbar_module_default()).nav__button__text,
                                children: t("common.help")
                            })
                        })
                    }),
                    authenticated ? !isMobile ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton/* default */.Z, {
                                onClick: handleClickUser,
                                "aria-label": "user",
                                size: "large",
                                color: "primary",
                                className: (Navbar_module_default()).nav__button,
                                children: userNotifications.length > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Badge/* default */.Z, {
                                    badgeContent: userNotifications.length,
                                    color: "error",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AccountCircle/* default */.Z, {
                                        className: (Navbar_module_default()).nav__button__icon__auth
                                    })
                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(AccountCircle/* default */.Z, {
                                    className: (Navbar_module_default()).nav__button__icon__auth
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Menu/* default */.Z, {
                                id: "basic-user-menu",
                                anchorEl: anchorEl,
                                open: open,
                                onClose: handleCloseUser,
                                MenuListProps: {
                                    "aria-labelledby": "basic-button"
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(MenuItem/* default */.Z, {
                                        style: {
                                            justifyContent: "center"
                                        },
                                        onClick: function(e) {
                                            e.preventDefault();
                                            router.push("/my_account/profile");
                                        },
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                            style: {
                                                cursor: "pointer"
                                            },
                                            className: (Navbar_module_default()).nav__button__text,
                                            children: t("pages.profile.title")
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(MenuItem/* default */.Z, {
                                        style: {
                                            justifyContent: "center"
                                        },
                                        onClick: function(e) {
                                            e.preventDefault();
                                            router.push("/my_account/orders");
                                        },
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                                            style: {
                                                cursor: "pointer",
                                                display: "flex",
                                                justifyContent: "center"
                                            },
                                            className: (Navbar_module_default()).nav__button__text,
                                            children: [
                                                t("pages.orders.title"),
                                                userNotifications.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    style: {
                                                        marginLeft: 10,
                                                        width: 25,
                                                        height: 25,
                                                        backgroundColor: "#d32f2f",
                                                        borderRadius: "100%"
                                                    },
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                                        style: {
                                                            color: "whitesmoke",
                                                            display: "flex",
                                                            height: 25,
                                                            fontSize: 14,
                                                            justifyContent: "center",
                                                            alignItems: "center"
                                                        },
                                                        children: userNotifications.length
                                                    })
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(MenuItem/* default */.Z, {
                                        style: {
                                            justifyContent: "center"
                                        },
                                        onClick: function(e) {
                                            e.preventDefault();
                                            logout();
                                        },
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Logout/* default */.Z, {
                                                sx: {
                                                    mr: 1
                                                }
                                            }),
                                            " ",
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                style: {
                                                    cursor: "pointer"
                                                },
                                                className: (Navbar_module_default()).nav__button__text,
                                                children: t("pages.my_account.logout")
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(UserWalletLinkIcon, {})
                        ]
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                href: "/my_account",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton/* default */.Z, {
                                    onClick: closeMenu,
                                    "aria-label": "user",
                                    size: "large",
                                    color: "primary",
                                    className: (Navbar_module_default()).nav__button,
                                    children: userNotifications.length > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Badge/* default */.Z, {
                                        badgeContent: userNotifications.length,
                                        color: "error",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AccountCircle/* default */.Z, {
                                            className: (Navbar_module_default()).nav__button__icon__auth
                                        })
                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(AccountCircle/* default */.Z, {
                                        className: (Navbar_module_default()).nav__button__icon__auth
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                style: {
                                    marginLeft: "2rem",
                                    paddingLeft: "2rem"
                                },
                                href: "/invite_friend",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton/* default */.Z, {
                                    onClick: closeMenu,
                                    "aria-label": "invite_friend",
                                    size: "large",
                                    color: "primary",
                                    className: (Navbar_module_default()).nav__button,
                                    style: {
                                        zIndex: 100
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Badge/* default */.Z, {
                                        color: "primary",
                                        badgeContent: "".concat((userDB === null || userDB === void 0 ? void 0 : userDB.wallet_balance) || 0, "€"),
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Wallet/* default */.Z, {
                                            className: (Navbar_module_default()).nav__button__icon__auth
                                        })
                                    })
                                })
                            })
                        ]
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                        href: "/login",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton/* default */.Z, {
                            onClick: closeMenu,
                            "aria-label": "user",
                            size: "large",
                            color: "primary",
                            className: (Navbar_module_default()).nav__button,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PersonOutlineOutlined/* default */.Z, {
                                className: (Navbar_module_default()).nav__button__icon,
                                sx: {
                                    strokeWidth: 1
                                }
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                        href: authenticated ? "/cart" : "/login",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton/* default */.Z, {
                            onClick: closeMenu,
                            "aria-label": "cart",
                            size: "large",
                            color: "primary",
                            className: (Navbar_module_default()).nav__button,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Badge/* default */.Z, {
                                badgeContent: itemCount,
                                color: "secondary",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ShoppingCartOutlined/* default */.Z, {
                                    className: (Navbar_module_default()).nav__button__icon
                                })
                            })
                        })
                    })
                ]
            })
        ]
    });
}

// EXTERNAL MODULE: ./components/layout/Header.module.css
var Header_module = __webpack_require__(44691);
var Header_module_default = /*#__PURE__*/__webpack_require__.n(Header_module);
// EXTERNAL MODULE: ./node_modules/@mui/material/Stack/Stack.js
var Stack = __webpack_require__(26447);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@mui/material/Accordion/Accordion.js + 3 modules
var Accordion = __webpack_require__(82280);
// EXTERNAL MODULE: ./node_modules/@mui/material/AccordionDetails/AccordionDetails.js + 1 modules
var AccordionDetails = __webpack_require__(22797);
// EXTERNAL MODULE: ./node_modules/@mui/material/Container/Container.js
var Container = __webpack_require__(46574);
// EXTERNAL MODULE: ./node_modules/@mui/material/Divider/Divider.js
var Divider = __webpack_require__(67720);
// EXTERNAL MODULE: ./components/layout/header/CategoriesMobile.module.css
var CategoriesMobile_module = __webpack_require__(75640);
var CategoriesMobile_module_default = /*#__PURE__*/__webpack_require__.n(CategoriesMobile_module);
;// CONCATENATED MODULE: ./components/layout/header/CategoriesMobile.tsx











function CategoriesMobile(param) {
    var setMenuIsExpanded = param.setMenuIsExpanded, setActiveCategory = param.setActiveCategory;
    var ref = (0,react.useState)(), categories = ref[0], setCategories = ref[1];
    var ref1 = (0,react.useState)(), categoriesDepartment = ref1[0], setCategoriesDepartment = ref1[1];
    var t = (0,useTranslation/* useTranslation */.$)().t;
    var router = (0,next_router.useRouter)();
    (0,react.useEffect)(function() {
        (0,supabaseApi/* getMarketPlaceCategories */.Ml)().then(function(categories) {
            if (categories) {
                setCategories(categories);
                var depName = categories.find(function(c) {
                    return c.name.toLowerCase() === constants/* DEPARTMENT_NAME.toLowerCase */.uj.toLowerCase();
                });
                var categoriesChild = [];
                if (depName) {
                    var ref;
                    categoriesChild = (ref = categories.find(function(c) {
                        return c.id === depName.id;
                    })) === null || ref === void 0 ? void 0 : ref.childCategories;
                    setCategoriesDepartment(categoriesChild);
                }
            }
        });
    }, []);
    var setActiveMenu = function(e) {
        if (!e.target.offsetParent.getElementsByTagName("p")[0].classList.contains("active")) {
            e.target.offsetParent.getElementsByTagName("p")[0].style.fontWeight = 700;
            e.target.offsetParent.getElementsByTagName("p")[0].classList.add("active");
        } else {
            e.target.offsetParent.getElementsByTagName("p")[0].style.fontWeight = 400;
            e.target.offsetParent.getElementsByTagName("p")[0].classList.remove("active");
        }
    };
    // TODO: Make scroll with 'categories__mobile__father' class
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (CategoriesMobile_module_default()).categories__mobile__father,
        children: [
            categories === null || categories === void 0 ? void 0 : categories.map(function(category, i) {
                if (category.name.toLowerCase() !== constants/* DEPARTMENT_NAME.toLowerCase */.uj.toLowerCase()) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Accordion/* default */.Z, {
                        className: (CategoriesMobile_module_default()).menu__accordion,
                        onClick: setActiveMenu,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (CategoriesMobile_module_default()).menu__accordion__summary,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                                    className: (CategoriesMobile_module_default()).menu__mobile__accordion__details
                                }, !category.childCategories.length && {
                                    onClick: function() {
                                        if (category.name.toLowerCase().includes("amazon")) {
                                            var categoryAmazon = category;
                                            // router.push(categoryAmazon.url)
                                            window.location.href = categoryAmazon.url;
                                        } else {
                                            router.push("/marketplaces/".concat(category.id, "?").concat(category.name));
                                        }
                                        setMenuIsExpanded(false);
                                        setActiveCategory(category.name.toUpperCase());
                                    }
                                }), {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                        children: category.name.toUpperCase()
                                    })
                                }))
                            }),
                            category.childCategories.map(function(child, i) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                    href: "/marketplaces/".concat(child.id, "?").concat(child.name),
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AccordionDetails/* default */.Z, {
                                        className: (CategoriesMobile_module_default()).menu__accordion__details,
                                        onClick: function() {
                                            setMenuIsExpanded(false);
                                            setActiveCategory(child.name.toUpperCase());
                                        },
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                            children: child.name.toUpperCase()
                                        })
                                    })
                                }, i);
                            })
                        ]
                    }, i);
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container/* default */.Z, {
                sx: {
                    pl: 2,
                    mt: 0
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                        href: "/marketplaces/all",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                            sx: {
                                fontWeight: "bold",
                                textTransform: "uppercase",
                                cursor: "pointer",
                                marginTop: "3%"
                            },
                            onClick: function() {
                                setMenuIsExpanded(false);
                                setActiveCategory("");
                            },
                            children: t("button.all_marketplaces")
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider/* default */.Z, {
                        style: {
                            margin: "2rem 0rem"
                        }
                    }),
                    categoriesDepartment === null || categoriesDepartment === void 0 ? void 0 : categoriesDepartment.map(function(category, i) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                            href: "/marketplaces/".concat(category.id, "?").concat(category.name),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                style: {
                                    marginTop: "0.9rem"
                                },
                                onClick: function() {
                                    router.push("/marketplaces/".concat(category.id, "?").concat(category.name));
                                    setMenuIsExpanded(false);
                                    setActiveCategory("");
                                },
                                children: category.name.toUpperCase()
                            })
                        }, i);
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                        href: "/custom-order",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                            style: {
                                marginBottom: 50
                            },
                            sx: {
                                height: 30,
                                p: 2,
                                mt: 2
                            },
                            onClick: function() {
                                return setMenuIsExpanded(false);
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                style: {
                                    fontWeight: "bold"
                                },
                                children: t("button.custom_order")
                            })
                        })
                    })
                ]
            })
        ]
    });
}

// EXTERNAL MODULE: ./node_modules/@mui/icons-material/KeyboardBackspace.js
var KeyboardBackspace = __webpack_require__(24613);
// EXTERNAL MODULE: ./components/layout/header/MenuHistory.module.css
var MenuHistory_module = __webpack_require__(80623);
var MenuHistory_module_default = /*#__PURE__*/__webpack_require__.n(MenuHistory_module);
;// CONCATENATED MODULE: ./components/layout/header/MenuHistory.tsx




function MenuHistory(param) {
    var activeCategory = param.activeCategory, setMenuIsExpanded = param.setMenuIsExpanded;
    var getBack = function() {
        setMenuIsExpanded(true);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (MenuHistory_module_default()).menu__history,
        onClick: getBack,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(KeyboardBackspace/* default */.Z, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                children: activeCategory
            })
        ]
    });
}

;// CONCATENATED MODULE: ./components/layout/Header.tsx















function Header() {
    var isMobile = (0,useMediaQuery/* default */.Z)("(max-width:".concat(constants/* MOBILE_WIDTH_LIMIT */.x9, "px)"));
    var ref = (0,react.useState)(false), menuIsExpanded = ref[0], setMenuIsExpanded = ref[1];
    var ref1 = (0,react.useState)(""), activeCategory = ref1[0], setActiveCategory = ref1[1];
    var isMarketplacesPage = (0,next_router.useRouter)().asPath.includes("marketplaces");
    var user = (0,Auth/* useAuth */.a)().user;
    var ref2 = (0,react.useState)(), userDB = ref2[0], setUserDB = ref2[1];
    (0,react.useEffect)(function() {
        getUserInfo();
    }, []);
    function getUserInfo() {
        return _getUserInfo.apply(this, arguments);
    }
    function _getUserInfo() {
        _getUserInfo = (0,_async_to_generator/* default */.Z)(function() {
            var data;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!user) return [
                            2,
                            null
                        ];
                        return [
                            4,
                            supabaseClient/* default.from */.Z.from("users").select("wallet_balance").eq("supabase_user_id", user.id).single()
                        ];
                    case 1:
                        data = _state.sent().data;
                        if (data) setUserDB(data);
                        return [
                            2
                        ];
                }
            });
        });
        return _getUserInfo.apply(this, arguments);
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("header", {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
                direction: "row",
                justifyContent: "space-between",
                alignItems: "center",
                marginBottom: 0,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Logo, {}),
                    isMobile && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        style: {
                            width: "50%"
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            style: {
                                display: "flex",
                                justifyContent: "space-between",
                                marginRight: "10%"
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    style: {
                                        width: "70%",
                                        height: 50,
                                        paddingTop: "5%",
                                        alignSelf: "center"
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                        style: {
                                            zIndex: 100
                                        },
                                        src: "/images/sequra-logo.png",
                                        alt: "sequra",
                                        width: "191px",
                                        height: "50px"
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    style: {
                                        width: "30%"
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                        href: "https://www.confianzaonline.es/empresas/syniva.htm",
                                        target: "_blank",
                                        rel: "noopener noreferrer",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                            style: {
                                                zIndex: 100
                                            },
                                            src: "/images/confianza-online.png",
                                            alt: "trustseal",
                                            width: "50%",
                                            height: "50%"
                                        })
                                    })
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Navbar, {
                        menuIsExpanded: menuIsExpanded,
                        setMenuIsExpanded: setMenuIsExpanded
                    })
                ]
            }),
            isMobile && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (Header_module_default()).container__header__up,
                        style: {
                            marginBottom: 15
                        },
                        children: isMarketplacesPage && !menuIsExpanded && /*#__PURE__*/ (0,jsx_runtime.jsx)(MenuHistory, {
                            activeCategory: activeCategory,
                            setMenuIsExpanded: setMenuIsExpanded
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "".concat((Header_module_default()).categories__mobile, " ").concat(menuIsExpanded && (Header_module_default()).expanded),
                        id: "menuList",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CategoriesMobile, {
                            setMenuIsExpanded: setMenuIsExpanded,
                            setActiveCategory: setActiveCategory
                        })
                    })
                ]
            })
        ]
    });
}

// EXTERNAL MODULE: ./components/Layout.module.css
var Layout_module = __webpack_require__(65918);
var Layout_module_default = /*#__PURE__*/__webpack_require__.n(Layout_module);
// EXTERNAL MODULE: ./node_modules/@mui/system/esm/Stack/Stack.js
var Stack_Stack = __webpack_require__(88085);
// EXTERNAL MODULE: ./components/footer/legal.tsx
var legal = __webpack_require__(5888);
// EXTERNAL MODULE: ./components/footer/social.tsx
var social = __webpack_require__(5831);
// EXTERNAL MODULE: ./components/footer/badges_app.tsx
var badges_app = __webpack_require__(29031);
// EXTERNAL MODULE: ./components/layout/Footer.module.css
var Footer_module = __webpack_require__(14525);
var Footer_module_default = /*#__PURE__*/__webpack_require__.n(Footer_module);
;// CONCATENATED MODULE: ./components/layout/FooterLayout.tsx










function FooterLayout() {
    var router = (0,next_router.useRouter)();
    var isHome = router.pathname === "/";
    var isMobile = (0,useMediaQuery/* default */.Z)("(max-width:".concat(constants/* MOBILE_WIDTH_LIMIT */.x9, "px)"));
    return isHome || isMobile ? null : /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
        direction: "row",
        bottom: 0,
        justifyContent: "space-between",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                sx: {
                    mr: 5,
                    alignSelf: "end"
                },
                style: {
                    alignSelf: "center "
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(social/* default */.Z, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(legal/* default */.Z, {})
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(badges_app/* default */.Z, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                href: "https://www.confianzaonline.es/empresas/syniva.htm",
                target: "_blank",
                rel: "noopener noreferrer",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                    className: (Footer_module_default()).footer__trustseal,
                    src: "/images/confianza-online.png",
                    alt: "trustseal",
                    width: "85%",
                    height: "85%"
                })
            })
        ]
    });
}

// EXTERNAL MODULE: ./node_modules/@mui/material/styles/styled.js
var styled = __webpack_require__(90948);
// EXTERNAL MODULE: ./components/navigation/MarketplaceStack.module.css
var MarketplaceStack_module = __webpack_require__(74355);
var MarketplaceStack_module_default = /*#__PURE__*/__webpack_require__.n(MarketplaceStack_module);
// EXTERNAL MODULE: ./node_modules/@mui/system/esm/Container/Container.js
var Container_Container = __webpack_require__(32045);
;// CONCATENATED MODULE: ./components/navigation/MarketplaceStack.tsx









var Item = (0,styled/* default */.ZP)(Box/* default */.Z)(function(param) {
    var theme = param.theme;
    return {
        padding: theme.spacing(1)
    };
});
function MarketplaceStack() {
    var ParentMarketplaceCategories = function ParentMarketplaceCategories() {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
            direction: "row",
            justifyContent: "center",
            flexWrap: "wrap",
            spacing: 2,
            children: [
                marketplaceCategories === null || marketplaceCategories === void 0 ? void 0 : marketplaceCategories.map(function(category) {
                    if (category.name.toLowerCase() !== constants/* DEPARTMENT_NAME.toLowerCase */.uj.toLowerCase()) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                            href: category.url ? category.url : "/marketplaces/".concat(category.id, "?").concat(category.name),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Item, {
                                className: (MarketplaceStack_module_default()).stack__item,
                                children: category.name.toLowerCase() === "amazon" ? /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                    src: "/images/amazon-logo.png",
                                    alt: "AMAZON",
                                    width: 80
                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                    // onMouseEnter={() => {
                                    //   setActiveCategory(category.id)
                                    //   setMarketplaceCategoriesFiltered(
                                    //     marketplaceCategories.find((c) => c.id === category.id)?.childCategories || []
                                    //   )
                                    // }}
                                    className: category.id === activeCategory && marketplaceCategoriesFiltered.length > 0 ? (MarketplaceStack_module_default()).stack__item__text_active : (MarketplaceStack_module_default()).stack__item__text,
                                    children: category.name
                                })
                            })
                        }, category.id);
                    }
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                    href: "/marketplaces/all",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Item, {
                        className: (MarketplaceStack_module_default()).stack__item,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                            className: (MarketplaceStack_module_default()).stack__item__text,
                            sx: {
                                textTransform: "uppercase",
                                cursor: "pointer"
                            },
                            children: t("button.all_marketplaces")
                        })
                    })
                })
            ]
        });
    };
    var ChildMarketplaceCategories = function ChildMarketplaceCategories() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            // onMouseLeave={() => {
            //   setMarketplaceCategoriesFiltered([])
            //   setActiveCategory(0)
            // }}
            className: (MarketplaceStack_module_default()).stack__subcategories,
            id: "stack__subcategories",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack/* default */.Z, {
                direction: "row",
                justifyContent: "center",
                spacing: 3,
                children: marketplaceCategoriesFiltered.map(function(category) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                        href: "/marketplaces/".concat(category.id, "?").concat(category.name),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Item, {
                            className: (MarketplaceStack_module_default()).stack__item,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                className: (MarketplaceStack_module_default()).stack__item__text,
                                children: category.name
                            })
                        })
                    }, category.id);
                })
            })
        });
    };
    var t = (0,useTranslation/* useTranslation */.$)().t;
    var ref = (0,react.useState)(), marketplaceCategories = ref[0], setMarketplaceCategories = ref[1];
    var ref1 = (0,react.useState)([]), marketplaceCategoriesFiltered = ref1[0], setMarketplaceCategoriesFiltered = ref1[1];
    var ref2 = (0,react.useState)(0), activeCategory = ref2[0], setActiveCategory = ref2[1];
    (0,react.useEffect)(function() {
        (0,supabaseApi/* getMarketPlaceCategories */.Ml)().then(function(categories) {
            if (categories) {
                setMarketplaceCategories(categories);
                var depName = categories.find(function(c) {
                    return c.name.toLowerCase() === constants/* DEPARTMENT_NAME.toLowerCase */.uj.toLowerCase();
                });
                if (depName) {
                    var ref;
                    setActiveCategory(depName.id);
                    setMarketplaceCategoriesFiltered(((ref = categories.find(function(c) {
                        return c.id === depName.id;
                    })) === null || ref === void 0 ? void 0 : ref.childCategories) || []);
                }
            }
        });
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container_Container/* default */.Z, {
        maxWidth: "lg",
        sx: {
            mb: 6
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ParentMarketplaceCategories, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ChildMarketplaceCategories, {})
        ]
    });
}

;// CONCATENATED MODULE: ./components/Layout.tsx








function Layout(param) {
    var children = param.children;
    var t = (0,useTranslation/* useTranslation */.$)().t;
    var isMobile = (0,useMediaQuery/* default */.Z)("(max-width:".concat(constants/* MOBILE_WIDTH_LIMIT */.x9, "px)"));
    var heightDiff = 350;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Header, {}),
            !isMobile && // <div style={{ width: '90%', marginLeft: '5%', display: 'flex', justifyContent: 'space-evenly' }}>
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (Layout_module_default()).carrousel_banner,
                style: {
                    display: "flex",
                    justifyContent: "space-evenly"
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(MarketplaceStack, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                        href: "/custom-order",
                        style: {
                            paddingTop: "2px"
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                style: {
                                    fontWeight: "bold",
                                    fontSize: "0.85rem",
                                    width: "max-content"
                                },
                                children: t("button.custom_order")
                            })
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("main", {
                className: (Layout_module_default()).main,
                style: {
                    minHeight: "calc(100vh - ".concat(heightDiff, "px)"),
                    marginBottom: 30
                },
                children: children
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (Layout_module_default()).carrousel_banner,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FooterLayout, {})
            })
        ]
    });
}


/***/ }),

/***/ 40918:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ InviteFriendInfoModal; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(10092);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(72908);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(87357);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(11057);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(7906);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(53184);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(53816);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(53252);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(295);
/* harmony import */ var react_i18next__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(77058);
/* harmony import */ var _InviteFriendInfoModal_module_css__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(57587);
/* harmony import */ var _InviteFriendInfoModal_module_css__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_InviteFriendInfoModal_module_css__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _mui_icons_material__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(41132);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _lib_currency__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(84810);









function InviteFriendInfoModal(param) {
    var userId = param.userId, open = param.open, setOpen = param.setOpen;
    var t = (0,react_i18next__WEBPACK_IMPORTED_MODULE_2__/* .useTranslation */ .$)().t;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)([]), benefits = ref[0], setBenefits = ref[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(0), wb = ref1[0], setWB = ref1[1];
    var style = {
        position: "absolute",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
        width: "98%",
        maxWidth: 750,
        bgcolor: "background.paper",
        boxShadow: 24,
        pl: 4,
        pb: 4,
        pr: 4,
        borderRadius: "1.25rem"
    };
    var dateNow = new Date(Date.now());
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(function() {
            var response, ref, referralBenefits, referrerBenefits, orders, walletBalance, benefitsData;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_4__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!userId) return [
                            2
                        ];
                        return [
                            4,
                            fetch("/api/actions/history/".concat(userId), {
                                method: "GET",
                                headers: {
                                    "Content-Type": "application/json"
                                }
                            })
                        ];
                    case 1:
                        response = _state.sent();
                        if (!response.ok) {
                            return [
                                2
                            ];
                        }
                        return [
                            4,
                            response.json()
                        ];
                    case 2:
                        ref = _state.sent(), referralBenefits = ref.referralBenefits, referrerBenefits = ref.referrerBenefits, orders = ref.orders, walletBalance = ref.walletBalance;
                        benefitsData = [];
                        referralBenefits.forEach(function(rb) {
                            benefitsData.push({
                                referred: true,
                                name: rb.referrer_user_id.id !== 0 ? rb.referred_user_id.name || "" : rb.referrer_user_id.name || "",
                                status: t("pages.invite_friend.info.".concat(rb.status)),
                                benefit_amount: rb.benefit_amount,
                                created_at: rb.created_at,
                                referrer_expired_at: rb.referred_expired_at || "",
                                expired: rb.referred_expired || false
                            });
                        });
                        referrerBenefits.forEach(function(rb) {
                            benefitsData.push({
                                referred: false,
                                name: rb.referred_user_id.name || "",
                                status: t("pages.invite_friend.info.".concat(rb.status)),
                                benefit_amount: rb.benefit_amount,
                                created_at: rb.created_at,
                                referrer_expired_at: rb.referrer_expired_at || "",
                                expired: rb.referrer_expired || false
                            });
                        });
                        orders.forEach(function(order) {
                            benefitsData.push({
                                referred: true,
                                name: "Pedido ".concat(order.id) || 0,
                                status: t("pages.invite_friend.info.used_in_order"),
                                benefit_amount: order.wallet_amount_used,
                                created_at: order.created_at,
                                expired: false
                            });
                        });
                        setBenefits(benefitsData.sort(function(a, b) {
                            return new Date(b.created_at).getTime() - new Date(a.created_at).getTime();
                        }));
                        setWB((walletBalance === null || walletBalance === void 0 ? void 0 : walletBalance.wallet_balance) || 0);
                        return [
                            2
                        ];
                }
            });
        })();
    }, [
        open
    ]);
    var handleCloseModal = function() {
        setOpen(false);
    };
    var getRowColor = function(status) {
        if (status === "pendiente") {
            return "#b7a936";
        } else if (status === "obtenido") {
            return "#41e121";
        } else if (status === "canjeado") {
            return "#d32f2f";
        } else if (status === "modificado") {
            return "#7f7f7f";
        }
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
            open: open,
            onClose: handleCloseModal,
            "aria-labelledby": "modal-modal-title",
            "aria-describedby": "modal-modal-description",
            className: (_InviteFriendInfoModal_module_css__WEBPACK_IMPORTED_MODULE_6___default().modal),
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                sx: style,
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                        children: t("pages.invite_friend.info.title")
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("b", {
                        children: t("pages.invite_friend.info.wallet_balance", {
                            value: wb
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                        className: (_InviteFriendInfoModal_module_css__WEBPACK_IMPORTED_MODULE_6___default().close_button),
                        onClick: handleCloseModal,
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_icons_material__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {})
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        style: {
                            overflow: "auto",
                            height: "50vh",
                            marginLeft: "-1rem"
                        },
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, {
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z, {
                                                children: t("pages.invite_friend.info.name")
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z, {
                                                align: "center",
                                                children: t("pages.invite_friend.info.status")
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z, {
                                                align: "center",
                                                children: t("pages.invite_friend.info.benefit_amount")
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z, {
                                                align: "center",
                                                children: t("pages.invite_friend.info.expired_at")
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z, {
                                    children: benefits.map(function(data, index) {
                                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, {
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z, {
                                                    className: (_InviteFriendInfoModal_module_css__WEBPACK_IMPORTED_MODULE_6___default().table_cell_bold),
                                                    children: data.name
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z, {
                                                    style: {
                                                        color: "".concat(getRowColor(data.referrer_expired_at && new Date(data.referrer_expired_at).toISOString() < dateNow.toISOString() ? t("pages.invite_friend.info.expired") : data.status.toLowerCase()))
                                                    },
                                                    className: (_InviteFriendInfoModal_module_css__WEBPACK_IMPORTED_MODULE_6___default().table_cell_bold),
                                                    align: "center",
                                                    children: data.expired ? t("pages.invite_friend.info.expired") : index === benefits.length - 1 && data.referred ? t("pages.invite_friend.info.accepted") : data.status
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z, {
                                                    className: (_InviteFriendInfoModal_module_css__WEBPACK_IMPORTED_MODULE_6___default().table_cell),
                                                    align: "center",
                                                    children: (0,_lib_currency__WEBPACK_IMPORTED_MODULE_15__/* .currency */ .A)(data.benefit_amount)
                                                }),
                                                data.referrer_expired_at ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z, {
                                                    className: (_InviteFriendInfoModal_module_css__WEBPACK_IMPORTED_MODULE_6___default().table_cell),
                                                    align: "center",
                                                    children: new Date(data.referrer_expired_at).toLocaleString().slice(0, -3)
                                                }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z, {
                                                    className: (_InviteFriendInfoModal_module_css__WEBPACK_IMPORTED_MODULE_6___default().table_cell),
                                                    align: "center"
                                                })
                                            ]
                                        }, index);
                                    })
                                })
                            ]
                        })
                    })
                ]
            })
        })
    });
}


/***/ }),

/***/ 29031:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ BadgesApp; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(15861);
/* harmony import */ var react_i18next__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(77058);
/* harmony import */ var _layout_Footer_module_css__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(14525);
/* harmony import */ var _layout_Footer_module_css__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_layout_Footer_module_css__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_1__);





function BadgesApp() {
    var t = (0,react_i18next__WEBPACK_IMPORTED_MODULE_2__/* .useTranslation */ .$)().t;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
        className: (_layout_Footer_module_css__WEBPACK_IMPORTED_MODULE_3___default().footer__badges),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                className: (_layout_Footer_module_css__WEBPACK_IMPORTED_MODULE_3___default().title),
                variant: "button",
                children: t("common.download_app")
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                href: "https://play.google.com/store/apps/details?id=com.syniva.syniva&gl=ES",
                target: "_blank",
                rel: "noreferrer",
                className: (_layout_Footer_module_css__WEBPACK_IMPORTED_MODULE_3___default().badge),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_1___default()), {
                    src: "/images/google-play-badge.png",
                    alt: "google play badge",
                    width: 90,
                    height: 32
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                href: "https://apps.apple.com/es/app/syniva/id6443994877",
                target: "_blank",
                rel: "noreferrer",
                className: (_layout_Footer_module_css__WEBPACK_IMPORTED_MODULE_3___default().badge),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_1___default()), {
                    src: "/images/app-store-badge.svg",
                    alt: "app store badge",
                    width: 100,
                    height: 28
                })
            })
        ]
    });
}


/***/ }),

/***/ 5888:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Legal; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _lib_supabaseApi__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(19627);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26447);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(23795);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(15861);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(67720);
/* harmony import */ var react_i18next__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(77058);
/* harmony import */ var _layout_Footer_module_css__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(14525);
/* harmony import */ var _layout_Footer_module_css__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_layout_Footer_module_css__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var _lib_cookies__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(82183);







function Legal() {
    var t = (0,react_i18next__WEBPACK_IMPORTED_MODULE_3__/* .useTranslation */ .$)().t;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(), urls = ref[0], setUrls = ref[1];
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        (0,_lib_supabaseApi__WEBPACK_IMPORTED_MODULE_1__/* .getLegal */ .E5)().then(function(res) {
            setUrls(res);
        });
    }, []);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
        direction: "row",
        className: (_layout_Footer_module_css__WEBPACK_IMPORTED_MODULE_5___default().footer__legal),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                href: urls === null || urls === void 0 ? void 0 : urls.policy,
                target: "_blank",
                rel: "noreferrer",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                    className: (_layout_Footer_module_css__WEBPACK_IMPORTED_MODULE_5___default().link),
                    children: t("common.privacy_cookies_policy")
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                orientation: "vertical",
                style: {
                    height: "1.5rem"
                }
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                href: urls === null || urls === void 0 ? void 0 : urls.legal,
                target: "_blank",
                rel: "noreferrer",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                    className: (_layout_Footer_module_css__WEBPACK_IMPORTED_MODULE_5___default().link),
                    children: t("common.legal_advise")
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                orientation: "vertical",
                style: {
                    height: "1.5rem"
                }
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                href: urls === null || urls === void 0 ? void 0 : urls.cookies,
                target: "_blank",
                rel: "noreferrer",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                    className: (_layout_Footer_module_css__WEBPACK_IMPORTED_MODULE_5___default().link),
                    children: t("common.cookies_policy")
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                orientation: "vertical",
                style: {
                    height: "1.5rem"
                }
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                onClick: function() {
                    (0,_lib_cookies__WEBPACK_IMPORTED_MODULE_9__/* .setCookie */ .d)("cookieBanner", "false", 0);
                    location.reload();
                },
                sx: {
                    cursor: "pointer"
                },
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                    className: (_layout_Footer_module_css__WEBPACK_IMPORTED_MODULE_5___default().link),
                    children: t("common.cookies_settings")
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                orientation: "vertical",
                style: {
                    height: "1.5rem"
                }
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                href: urls === null || urls === void 0 ? void 0 : urls.buy,
                target: "_blank",
                rel: "noreferrer",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                    className: (_layout_Footer_module_css__WEBPACK_IMPORTED_MODULE_5___default().link),
                    children: t("common.terms_conditions")
                })
            })
        ]
    });
}


/***/ }),

/***/ 5831:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Social; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _lib_constants__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(59953);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(26447);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(23795);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(15861);
/* harmony import */ var _layout_Footer_module_css__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(14525);
/* harmony import */ var _layout_Footer_module_css__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_layout_Footer_module_css__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _mui_icons_material_Instagram__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(94020);
/* harmony import */ var _mui_icons_material_YouTube__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(64871);
/* harmony import */ var _mui_icons_material_X__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(72876);
/* harmony import */ var _mui_icons_material_Facebook__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(60802);








function Social() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
        direction: "row",
        className: (_layout_Footer_module_css__WEBPACK_IMPORTED_MODULE_3___default().footer__social),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                style: {
                    display: "flex",
                    textAlign: "center",
                    textDecoration: "none",
                    color: "rgb(66, 66, 66)"
                },
                href: _lib_constants__WEBPACK_IMPORTED_MODULE_1__/* .SOCIAL_LINKS.instagram */ .fK.instagram,
                target: "_blank",
                rel: "noreferrer",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_icons_material_Instagram__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                        className: (_layout_Footer_module_css__WEBPACK_IMPORTED_MODULE_3___default().instagram)
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                        className: (_layout_Footer_module_css__WEBPACK_IMPORTED_MODULE_3___default().link),
                        children: "Instagram"
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                style: {
                    display: "flex",
                    textAlign: "center",
                    textDecoration: "none",
                    color: "rgb(66, 66, 66)"
                },
                href: _lib_constants__WEBPACK_IMPORTED_MODULE_1__/* .SOCIAL_LINKS.tiktok */ .fK.tiktok,
                target: "_blank",
                rel: "noreferrer",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                        src: "/images/TikTok-logo.png",
                        alt: "Logo de Tiktok",
                        width: 20
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                        className: (_layout_Footer_module_css__WEBPACK_IMPORTED_MODULE_3___default().link),
                        children: "TikTok"
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                style: {
                    display: "flex",
                    textAlign: "center",
                    textDecoration: "none",
                    color: "rgb(66, 66, 66)"
                },
                href: _lib_constants__WEBPACK_IMPORTED_MODULE_1__/* .SOCIAL_LINKS.youtube */ .fK.youtube,
                target: "_blank",
                rel: "noreferrer",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_icons_material_YouTube__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                        className: (_layout_Footer_module_css__WEBPACK_IMPORTED_MODULE_3___default().youtube)
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                        className: (_layout_Footer_module_css__WEBPACK_IMPORTED_MODULE_3___default().link),
                        children: "Youtube"
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                style: {
                    display: "flex",
                    textAlign: "center",
                    textDecoration: "none",
                    color: "rgb(66, 66, 66)"
                },
                href: _lib_constants__WEBPACK_IMPORTED_MODULE_1__/* .SOCIAL_LINKS.x */ .fK.x,
                target: "_blank",
                rel: "noreferrer",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_icons_material_X__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                        className: (_layout_Footer_module_css__WEBPACK_IMPORTED_MODULE_3___default().x)
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                        className: (_layout_Footer_module_css__WEBPACK_IMPORTED_MODULE_3___default().link),
                        children: "X"
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                style: {
                    display: "flex",
                    textAlign: "center",
                    textDecoration: "none",
                    color: "rgb(66, 66, 66)"
                },
                href: _lib_constants__WEBPACK_IMPORTED_MODULE_1__/* .SOCIAL_LINKS.facebook */ .fK.facebook,
                target: "_blank",
                rel: "noreferrer",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_icons_material_Facebook__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                        className: (_layout_Footer_module_css__WEBPACK_IMPORTED_MODULE_3___default().facebook)
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                        className: (_layout_Footer_module_css__WEBPACK_IMPORTED_MODULE_3___default().link),
                        children: "Facebook"
                    })
                ]
            })
        ]
    });
}


/***/ }),

/***/ 65918:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"carrousel_banner":"Layout_carrousel_banner__0eEjK"};

/***/ }),

/***/ 57587:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"modal":"InviteFriendInfoModal_modal__xo8IJ","close_button":"InviteFriendInfoModal_close_button__dxATo","table_cell_bold":"InviteFriendInfoModal_table_cell_bold__QtWPE","table_cell":"InviteFriendInfoModal_table_cell__Ru43n"};

/***/ }),

/***/ 99640:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"button":"MarketplaceSearchButton_button__DxFqC"};

/***/ }),

/***/ 40107:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"logo":"Logo_logo__qaQep"};

/***/ }),

/***/ 14525:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"footer":"Footer_footer__2MMdT","footer__links":"Footer_footer__links__GpU4j","footer__trustseal":"Footer_footer__trustseal__PcfX_","footer__ecommerce":"Footer_footer__ecommerce__av8R2","footer__legal":"Footer_footer__legal__Ripri","footer__social":"Footer_footer__social__10uvU","link":"Footer_link__OMLqp","instagram":"Footer_instagram__AztZE","youtube":"Footer_youtube__31Njo","x":"Footer_x__nGw_o","facebook":"Footer_facebook__hQF9N","footer__badges":"Footer_footer__badges__pW95k","title":"Footer_title__1ogTI","badge":"Footer_badge__8qiRG","social":"Footer_social__B92hy"};

/***/ }),

/***/ 44691:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"header":"Header_header__RvT3c","navbar":"Header_navbar__qb1eg","container__header__up":"Header_container__header__up__6OVEI","categories__mobile":"Header_categories__mobile__WvKnZ","expanded":"Header_expanded__crOuB"};

/***/ }),

/***/ 6022:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"nav":"Navbar_nav__8sUxk","navbar__icons":"Navbar_navbar__icons__N1Msz","nav__button":"Navbar_nav__button__gfGpL","nav__button__icon":"Navbar_nav__button__icon__seJTW","nav__button__icon__auth":"Navbar_nav__button__icon__auth__lFI9o","nav__button__icon__authenticated":"Navbar_nav__button__icon__authenticated__YJSLT","nav__button__icon__notifications":"Navbar_nav__button__icon__notifications__TeDNt","container":"Navbar_container__w3JnY","help__button":"Navbar_help__button__vsh9G","navbar__buttons":"Navbar_navbar__buttons__cyVgO","nav__button__text":"Navbar_nav__button__text__EgRsC"};

/***/ }),

/***/ 75640:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"custom__order":"CategoriesMobile_custom__order__eTAZC","button__custom__order":"CategoriesMobile_button__custom__order__Q_EfG","stack__item__text":"CategoriesMobile_stack__item__text__dKFJn","menu__accordion":"CategoriesMobile_menu__accordion__HYw0B","menu__accordion__details":"CategoriesMobile_menu__accordion__details__9SD3G","menu__mobile__accordion__details":"CategoriesMobile_menu__mobile__accordion__details__qdmjs","categories__mobile__father":"CategoriesMobile_categories__mobile__father__Hrxis","menu__mobile__buttons":"CategoriesMobile_menu__mobile__buttons__2iqbA"};

/***/ }),

/***/ 80623:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"menu__history":"MenuHistory_menu__history__ayzde"};

/***/ }),

/***/ 74355:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"stack":"MarketplaceStack_stack__3s6EH","stack__item":"MarketplaceStack_stack__item__PrMxF","stack__item__all":"MarketplaceStack_stack__item__all__QuSCp","stack__close":"MarketplaceStack_stack__close__qkmJx","stack__item__text":"MarketplaceStack_stack__item__text__vURB2","stack__item__text_active":"MarketplaceStack_stack__item__text_active__LqT69","stack__subcategories":"MarketplaceStack_stack__subcategories__KmX3R"};

/***/ })

}]);